import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  height: 100%;
  background-color: ${COLORS.white};
  margin-right: 1rem;
`

export const SelectedProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 0.5rem;
  overflow-y: auto;
`

export const NoMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  p {
    color: ${COLORS.darkGray};
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  span {
    color: ${COLORS.darkGray};
    font-size: 1rem;
  }
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  gap: 1rem;
`

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;

  @media (max-width: 968px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 0.75rem;

    > *:first-child {
      flex: 0 0 auto;
    }

    > *:last-child {
      flex: 0 0 auto;
      margin-left: auto;
    }

    > *:nth-child(2) {
      flex: 1 1 100%;
      order: 3;
      margin-top: 0.5rem;
    }
  }
`

export const NoteContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background-color: ${COLORS.gray};
  border-radius: 8px;
  border-left: 4px solid ${COLORS.secondary};
  padding: 0.75rem 1rem;
  flex: 1;
  min-width: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 968px) {
    padding: 0.75rem 1rem;
    gap: 0.5rem;
    width: 100%;
    flex: 1 1 100%;
  }
`

export const NoteIcon = styled.div`
  color: ${COLORS.secondary};
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 0.1rem;
  flex-shrink: 0;
`

export const NoteText = styled.div`
  color: ${COLORS.lightBlack};
  font-size: 0.9rem;
  line-height: 1.4;
  text-align: left;
  margin: 0;
  flex: 1;

  .note-label {
    font-weight: 600;
    color: ${COLORS.secondary};
    margin-right: 0.5rem;
    display: inline;
  }

  .note-content {
    font-style: italic;
    display: inline;
  }

  @media (max-width: 968px) {
    font-size: 0.85rem;
    line-height: 1.3;

    .note-label {
      display: block;
      margin-bottom: 0.25rem;
      margin-right: 0;
    }

    .note-content {
      display: block;
    }
  }
`
